import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      background: '#f8fafc',
      padding: '1.5rem 0 1rem 0',
      marginTop: 'auto',
      borderTop: '1px solid #e5e7eb'
    }} className="px-3 px-md-0">
      <div className="container">
        <div className="row">
          {/* Company Information */}
          <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
            <div style={{ marginBottom: '1rem' }}>
              <h5 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
                Publication Hub
              </h5>
              <p style={{ color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                A comprehensive platform for managing and accessing research papers, newsletters, 
                weekly highlights, and industry insights from leading professionals.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6 col-sm-6 mb-1">
            <h6 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
              Quick Links
            </h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Home
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/publications" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  All Publications
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/weekly-highlights" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Weekly Highlights
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/about" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Publication Types */}
          <div className="col-lg-2 col-md-6 col-sm-6 mb-1">
            <h6 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
              Publications
            </h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/research-paper" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Research Papers
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                                <a href="/newsletters" style={{
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Newsletters
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/blogs" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Blogs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
            <h6 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '1rem' }}>
              Contact Us
            </h6>
            <div style={{ marginBottom: '1rem' }}>
              <p style={{ color: '#6b7280', margin: '0 0 0.5rem 0' }}>
                Have questions or need support?
              </p>
              <a href="/contact" style={{
                display: 'inline-block',
                background: '#6366f1',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                textDecoration: 'none',
              fontWeight: '500',
                transition: 'all 0.3s ease',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#4f46e5';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#6366f1';
                e.target.style.transform = 'translateY(0)';
              }}>
                Get in Touch
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={{
          borderTop: '1px solid #e5e7eb',
          paddingTop: '1.5rem',
          marginTop: '1.5rem'
        }}>
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12 mb-2 mb-md-0">
              <p style={{ color: '#6b7280', margin: 0, fontSize: '0.9rem' }} className="text-center text-md-start">
                © 2025 DBohra Publications. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 col-sm-12 text-center text-md-end">
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }} className="justify-content-center justify-content-md-end">
                <a href="/privacy-policy" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Privacy Policy
                </a>
                <a href="/terms-and-conditions" style={{ 
                  color: '#6b7280', 
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#6366f1'}
                onMouseLeave={(e) => e.target.style.color = '#6b7280'}>
                  Terms and Conditions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 